module.exports = __webpack_public_path__ + "../resources/img/ic-re-notification-push-red.b165c5f1.svg";